import React, { useState, useEffect } from "react";
import UploadPhoto from "../../Assets/images/UploadPhoto.svg";
import "../../Assets/styles/newStyles/EditProfileDialog.css";
import ApiService from "../../Services/ApiServices";
import "react-phone-input-2/lib/style.css";
import { useParams } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";
import PhoneInput from "react-phone-input-2";

export const EditProfileDialog = (props) => {
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [createdDoctorName, setCreatedDoctorName] = useState("");
  const [isSuccessDialogOpen, setisSuccessDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [originalDoctorData, setOriginalDoctorData] = useState(null);
  const [loader, setLoader] = useState(false);
  const [doctorData, setDoctorData] = useState({
    firstname: "",
    salutation: "Dr.",
    lastname: "",
    contact: "",
    password: "",
    hospitals: "",
    qualifications: "",
    zipcode: "",
    locations: "",
    state: "",
    country: "",
  });

  const apiService = new ApiService();

  useEffect(() => {
    setDialogOpen(props.open);
    // Prevent body scroll when dialog is open
    document.body.style.overflow = props.open ? "hidden" : "unset";
    if (props.open) {
      // Fetch profile data when dialog opens
      fetchProfileData();
    }
  }, [props.open]);

  const params = useParams();

  const doctorID = params.loginId;

  const fetchProfileData = async () => {
    try {
      const response = await apiService.getProfile(doctorID);
      if (response.status === "Success") {
        const fetchedData = response.data || {
          firstname: "",
          salutation: "Dr.",
          lastname: "",
          contact: "",
          password: "",
          hospitals: "",
          qualifications: "",
          zipcode: "",
          locations: "",
          state: "",
          country: "",
        };
        setDoctorData(fetchedData);
        setOriginalDoctorData(fetchedData); // Store original data for comparison
      } else {
        console.error("Error fetching profile data:", response.message);
        setErrorMessage(response.message);
      }
    } catch (error) {
      console.error("Error fetching profile data:", error);
      setErrorMessage('An error occurred while updating doctor. Please try again.');
    }
  };

  const isDataModified = () => {
    return JSON.stringify(doctorData) !== JSON.stringify(originalDoctorData);
  };

  const closeDialog = () => {
    setDialogOpen(false);
    if (props.onClose) {
      setDoctorData({
        firstname: "",
        salutation: "Dr.",
        lastname: "",
        email: "",
        contact: "",
        password: "",
        hospitals: "",
        qualifications: "",
        zipcode: "",
        locations: "",
        state: "",
        country: "",
      });
      setSelectedFile(null);
      setErrorMessage('');
      setisSuccessDialogOpen(false);
      props.onClose();
    }
    window.location.reload();
  };

  const close = () => {
    setDialogOpen(false);
    if (props.onClose) {
      setDoctorData({
        firstname: "",
        salutation: "Dr.",
        lastname: "",
        email: "",
        contact: "",
        password: "",
        hospitals: "",
        qualifications: "",
        zipcode: "",
        locations: "",
        state: "",
        country: "",
      });
      setSelectedFile(null);
      setErrorMessage('');
      setisSuccessDialogOpen(false);
      props.onClose();
    }
  };

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleSave = async () => {
    let errors = [];

    if (!doctorData.firstname?.trim()) {
      errors.push("firstname");
    }
    if (!doctorData.lastname?.trim()) {
      errors.push("lastname");
    }
  
    const digitsOnly = doctorData.contact.replace(/\D/g, ""); // Remove non-digit characters
    if (digitsOnly.length <= 2) {  // Assuming country code length is 2 digits (e.g., +91)
      errors.push("contact");
    }
    if (errors.length > 0) {
      setErrorMessage(`Missing mandatory fields: ${errors.join(", ")}`);
      return; // Stop execution if errors exist
    }
  
    // Check for validation errors
    if (errors.length > 0) {
      setErrorMessage(errors);
      return; // Stop execution if errors exist
    }
    try {
      setLoader(true); // Start loader
      const result = await apiService.updateDoctor(doctorData);
      console.log(result);
      if (result.status === "Success") {
        setCreatedDoctorName(
          `${doctorData.salutation} ${doctorData.firstname} ${doctorData.lastname}`
        );
        setDialogOpen(false);
        setisSuccessDialogOpen(true);
      } else {
        setErrorMessage(result.message);
      }
    } catch (error) {
      console.error("Error updating doctor:", error);
      setErrorMessage("An error occurred while updating doctor. Please try again.");
    } finally {
      setLoader(false); // Stop loader after execution
    }
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setDoctorData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };

  return (
    <>
      {isDialogOpen && (
        <>
          {/* Grey-out overlay */}
          <div className="dialog-overlay"></div>
          <div className={`doctordialog ${isDialogOpen ? "open" : ""}`}>
          {loader ? (
            <div className="loadingdiv">
              <ClipLoader color={"#007bff"} loading={loader} size={30} />
            </div>
          ) : (
            <>
            <div className="doctordialog-title">
              <h2 style={{ color: "#354764", fontSize: "15px" }}>
                Edit Profile
              </h2>
              <p
                style={{
                  color: "#E63900",
                  fontWeight: "bold",
                  fontSize: "10px",
                  cursor: "pointer"
                }}
                onClick={close}
              >
                Close
              </p>
            </div>
            <div className="doctordialog-content">
              <div className="content-container">
                {/* Upload Photo Section */}
                <div className="upload-section">
                  <input
                    accept="image/*"
                    style={{ display: "none" }}
                    id="upload-photo"
                    type="file"
                    onChange={handleFileChange}
                  />
                  {selectedFile && (
                    <img
                      src={URL.createObjectURL(selectedFile)}
                      alt="Profile Preview"
                      className="profile-preview"
                    />
                  )}
                  <label htmlFor="upload-photo" className="upload-button">
                    <img src={UploadPhoto} alt="Upload" />
                  </label>
                </div>
                {/* Mandatory Fields Section */}
                <div className="fields-section">
                  <h3
                    style={{
                      color: "#FFAA32",
                      fontSize: "12px",
                      marginBottom: "15px",
                    }}
                  >
                    Mandatory Fields
                  </h3>
                  <div className="name-fields">
                    <div className="field-container" style={{ width: "100%" }}>
                      <label htmlFor="firstname" className="field-label">
                        First Name
                      </label>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <select
                          style={{
                            color: "#243757",
                            fontSize: "11px",
                            marginRight: "5px",
                            paddingLeft: "1px",
                            width: "38%",
                          }}
                          id="salutation"
                          className="select-field"
                          value={doctorData.salutation}
                          onChange={handleChange}
                        >
                          <option value="Dr.">Dr.</option>
                          <option value="Mr.">Mr.</option>
                          <option value="Ms.">Ms.</option>
                          <option value="Mrs.">Mrs.</option>
                        </select>

                        <input
                          id="firstname"
                          type="text"
                          placeholder="Enter First Name"
                          className="input-field"
                          value={doctorData.firstname || ""}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^[a-zA-Z\s]*$/.test(value)) {
                              setDoctorData({ ...doctorData, firstname: value });
                              setErrorMessage('');  
                            } else {
                              setErrorMessage('Only alphabets and spaces are allowed.');
                            }
                          }}
                        />
                      </div>
                    </div>

                    <div className="field-container" style={{ width: "80%" }}>
                      <label htmlFor="lastname" className="field-label">
                        Last Name
                      </label>
                      <input
                        style={{ color: "#243757", fontSize: "11px" }}
                        id="lastname"
                        type="text"
                        placeholder="Last Name"
                        className="input-field"
                        value={doctorData.lastname || ""}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^[a-zA-Z\s]*$/.test(value)) {
                            setDoctorData({ ...doctorData, lastname: value });
                            setErrorMessage('');  
                          } else {
                            setErrorMessage('Only alphabets and spaces are allowed.');
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div className="flex-space-between">
                    <div className="field-container half-width">
                      <label htmlFor="contact" className="field-label">
                        Contact
                      </label>
                      <PhoneInput
                        country={"in"}
                        id="contact"
                        value={doctorData.contact || ""}
                        onChange={(phone) =>
                          setDoctorData({ ...doctorData, contact: phone.startsWith('+') ? phone : `+${phone}` })
                        }
                        inputStyle={{
                          color: "#243757",
                          fontSize: "11px",
                          width: "100%",
                        }}
                        placeholder="Enter Contact"
                        countryCodeEditable={false}
                        enableSearch
                      />
                    </div>
                  </div>
                </div>
              </div>

              <h3
                style={{
                  color: "#FFAA32",
                  fontSize: "12px",
                  marginBottom: "15px",
                }}
              >
                Optional Fields
              </h3>
              <div className="name-fields">
                <div className="field-container" style={{ width: "48%" }}>
                  <label
                    style={{ fontSize: "10px" }}
                    htmlFor="hospitals"
                    className="field-label"
                  >
                    Hospital
                  </label>
                  <input
                    style={{ color: "#243757", fontSize: "11px" }}
                    id="hospitals"
                    type="text"
                    placeholder="Enter Hospital Name"
                    className="input-field"
                    value={doctorData.hospitals || ""}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^[a-zA-Z\s]*$/.test(value)) {
                        setDoctorData({ ...doctorData, hospitals: value });
                        setErrorMessage('');  
                      } else {
                        setErrorMessage('Only alphabets and spaces are allowed.');
                      }
                    }}
                  />
                </div>
                <div className="field-container" style={{ width: "48%" }}>
                  <label
                    style={{ fontSize: "10px" }}
                    htmlFor="qualifications"
                    className="field-label"
                  >
                    Qualification
                  </label>
                  <input
                    style={{ color: "#243757", fontSize: "11px" }}
                    id="qualifications"
                    type="text"
                    placeholder="Enter Qualification"
                    className="input-field"
                    value={doctorData.qualifications || ""}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^[a-zA-Z\s]*$/.test(value)) {
                        setDoctorData({ ...doctorData, qualifications: value });
                        setErrorMessage('');  
                      } else {
                        setErrorMessage('Only alphabets and spaces are allowed.');
                      }
                    }}
                  />
                </div>
              </div>

              <div className="name-fields">
                <div className="field-container" style={{ width: "48%" }}>
                  <label
                    style={{ fontSize: "10px" }}
                    htmlFor="locations"
                    className="field-label"
                  >
                    City
                  </label>
                  <input
                    style={{ color: "#243757", fontSize: "11px" }}
                    id="locations"
                    type="text"
                    placeholder="Enter City"
                    className="input-field"
                    value={doctorData.locations || ""}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^[a-zA-Z\s]*$/.test(value)) {
                        setDoctorData({ ...doctorData, locations: value });
                        setErrorMessage('');  
                      } else {
                        setErrorMessage('Only alphabets and spaces are allowed.');
                      }
                    }}
                  />
                </div>
                <div className="field-container" style={{ width: "48%" }}>
                  <label
                    style={{ fontSize: "10px" }}
                    htmlFor="state"
                    className="field-label"
                  >
                    State
                  </label>
                  <input
                    style={{ color: "#243757", fontSize: "11px" }}
                    id="state"
                    type="text"
                    placeholder="Enter State"
                    className="input-field"
                    value={doctorData.state || ""}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^[a-zA-Z\s]*$/.test(value)) {
                        setDoctorData({ ...doctorData, state: value });
                        setErrorMessage('');  
                      } else {
                        setErrorMessage('Only alphabets and spaces are allowed.');
                      }
                    }}
                  />
                </div>
              </div>

              <div className="name-fields">
                <div className="field-container" style={{ width: "48%" }}>
                  <label
                    style={{ fontSize: "10px" }}
                    htmlFor="country"
                    className="field-label"
                  >
                    Country
                  </label>
                  <input
                    style={{ color: "#243757", fontSize: "11px" }}
                    id="country"
                    type="text"
                    placeholder="Enter Country"
                    className="input-field"
                    value={doctorData.country || ""}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^[a-zA-Z\s]*$/.test(value)) {
                        setDoctorData({ ...doctorData, country: value });
                        setErrorMessage('');  
                      } else {
                        setErrorMessage('Only alphabets and spaces are allowed.');
                      }
                    }}
                  />
                </div>
                <div className="field-container" style={{ width: "48%" }}>
                  <label
                    style={{ fontSize: "10px" }}
                    htmlFor="Postal Code"
                    className="field-label"
                  >
                    Postal Code
                  </label>
                  <input
                    style={{ color: "#243757", fontSize: "11px" }}
                    id="zipcode"
                    type="text"
                    placeholder="Enter Postal Code"
                    className="input-field"
                    value={doctorData.zipcode || ""}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*$/.test(value)) {
                        setDoctorData({ ...doctorData, zipcode: value });
                        setErrorMessage('');  
                      } else {
                        setErrorMessage('Only numbers are allowed.');
                      }
                    }}
                  />
                </div>
              </div>


              {/* Error Message Display */}
              {errorMessage && (
                <div className="error-message">{errorMessage}</div>
              )}

              <div className="submit-section">
                <button className="submit-button" onClick={handleSave} disabled={!isDataModified()}>
                  Save
                </button>
              </div>
            </div>
            </>
          )}
          </div>
        </>
      )}
      {isSuccessDialogOpen && (
        <>
          {/* Grey-out overlay */}
          <div className="dialog-overlay"></div>
          <div className="success-dialog">
            <div className="success-title-container">
              <h3 className="success-title">Doctor Profile Updated</h3>
              <div className="success-line"></div>
            </div>

            <div className="success-doctor-name">
              <p>{createdDoctorName}</p>
            </div>

            <div className="success-actions-container">
              <button
                className="view-profile-button"
                onClick={closeDialog}
              >
                Close
              </button>
            </div>
          </div>
        </>
      )}
    </>
  );
};
